import {openInNewTab} from 'shared/web';

import {CARVAGO_TRANSACTION_WORKSPACE_URLS} from '../constants/carvagoTransactionWorkspaceUrls';

export const getCarvagoTransactionWorkspaceUrl = () =>
  process.env.ENV_TYPE === 'prod'
    ? CARVAGO_TRANSACTION_WORKSPACE_URLS.prod
    : CARVAGO_TRANSACTION_WORKSPACE_URLS.other;

export const openCarvagoTransactionWorkspace = () => {
  openInNewTab(getCarvagoTransactionWorkspaceUrl());
};
